import { render, staticRenderFns } from "./childModal.vue?vue&type=template&id=00712b83&scoped=true&"
import script from "./childModal.vue?vue&type=script&lang=ts&"
export * from "./childModal.vue?vue&type=script&lang=ts&"
import style1 from "./childModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00712b83",
  null
  
)

export default component.exports